import React from 'react'
import { Flex } from '@components'
import { Button, Descriptions, Spin, message } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import Hint from '@pages/SelfHelp/common/hint'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import NHFetch from '@utils/NHFetch'
import { getLoginUser } from '@utils/NHCore'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import './index.css'

export default class StudentInfoConfirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mkbz: 'GD001_12',
      hjmc: '',
      xsInfo: {},
      loading: false,
      confirmLoading: false,
      infoConfirmed: false,
      blztFlag: '0',
      operable: true,
      nonOperationalData: {},
      nextUrl: '',
      search: ''
    }
  }

  componentDidMount() {
    this.queryQztjAndYlhj()
    this.loadXsInfo()
  }

  queryQztjAndYlhj = () => {
    const xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    const zzbdhjid = this.getQueryString('pkid')
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid, zzbdhjid }).then(res => {
      if (res && res.data) {
        const kfsj = res.data['kfsj']
        const ylhj = res.data['ylhj']
        const qzhj = res.data['qzhj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] !== '1') {
          this.setState({ operable: false })
        }
        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }
        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }
      }
    })
  }

  loadXsInfo = () => {
    const xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    this.setState({ loading: true })
    NHFetch('/tsxy/zzbd/queryXsInfo', 'GET', { xsid }).then(res => {
      if (res && res.code === 200) {
        this.setState({ xsInfo: res.data || {}, loading: false })
      } else {
        this.setState({ loading: false })
      }
    })
  }

  getQueryString = name => {
    return (
      decodeURIComponent(
        (
          new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, '']
        )[1].replace(/\+/g, '%20')
      ) || null
    )
  }

  setMenuList = menuList => {
    let currentIndex = -1
    menuList.forEach((elem, index) => {
      if (elem.HJDM === this.state.mkbz) {
        currentIndex = index
        const blztFlag = elem.BLZT || '0'
        this.setState({
          hjmc: elem.HJMC,
          blztFlag,
          infoConfirmed: blztFlag !== '0'
        })
      }
    })

    const nextCount = currentIndex + 1
    const menu = menuList[nextCount]
    if (menu) {
      const hjdm = menu.HJDM
      if (hjdm.indexOf('GD') === 0) {
        const gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') === 0) {
        const zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      } else if (hjdm.indexOf('DCWJ') === 0) {
        const wjUrl = '/customizeExamination'
        this.setState({
          nextUrl: wjUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm
        })
      }
    }
  }

  handleConfirm = () => {
    const xsid = getLoginUser() ? getLoginUser().userId : ''
    const zzbdhjid = this.getQueryString('pkid')
    if (!xsid) {
      message.error('未获取登录信息')
      return
    }
    if (!zzbdhjid) {
      message.error('未获取环节信息')
      return
    }
    this.setState({ confirmLoading: true })
    NHFetch('/tsxy/zzbd/confirmXsInfo', 'POST', { xsid, zzbdhjid }).then(res => {
      if (res && res.code === 200 && res.data === 1) {
        message.success('已确认信息无误')
        this.setState({ infoConfirmed: true, blztFlag: '1' })
        this.reloadMenu()
      } else {
        message.error(res && res.msg ? res.msg : '确认失败')
      }
      this.setState({ confirmLoading: false })
    })
  }

  reloadMenu = () => {
    if (this.refs.siderMenu && this.refs.siderMenu.reloadMenuList) {
      this.refs.siderMenu.reloadMenuList()
    }
  }

  renderInfo = () => {
    const info = this.state.xsInfo || {}
    return (
      <Descriptions bordered size="small" column={2} className="infoConfirmDesc">
        <Descriptions.Item label="姓名">{info.XM}</Descriptions.Item>
        <Descriptions.Item label="性别">{info.XB}</Descriptions.Item>
        <Descriptions.Item label="身份证件类型">{info.SFZJLX}</Descriptions.Item>
        <Descriptions.Item label="身份证件号">{info.SFZJH}</Descriptions.Item>
        <Descriptions.Item label="民族">{info.MZ}</Descriptions.Item>
        <Descriptions.Item label="政治面貌">{info.ZZMM}</Descriptions.Item>
        <Descriptions.Item label="生源地">{info.SYD}</Descriptions.Item>
        <Descriptions.Item label="学生类别">{info.XSLB}</Descriptions.Item>
        <Descriptions.Item label="入学年份">{info.RXNF}</Descriptions.Item>
        <Descriptions.Item label="学院">{info.BMMC}</Descriptions.Item>
        <Descriptions.Item label="专业">{info.ZYMC}</Descriptions.Item>
        <Descriptions.Item label="校区">{info.XQMC}</Descriptions.Item>
        <Descriptions.Item label="手机号码">{info.SJHM}</Descriptions.Item>
        <Descriptions.Item label="考生号">{info.KSH}</Descriptions.Item>
        <Descriptions.Item label="高考成绩">{info.GKCJ}</Descriptions.Item>
        <Descriptions.Item label="学生来源">{info.XSLY}</Descriptions.Item>
        <Descriptions.Item label="家庭所在地">{info.JTSZDZ}</Descriptions.Item>
        <Descriptions.Item label="录取通知书邮寄地址" span={2}>{info.LQTZSYJDZ}</Descriptions.Item>
      </Descriptions>
    )
  }

  render() {
    const { operable, loading, confirmLoading, nextUrl, search, infoConfirmed, blztFlag } = this.state
    const canNext = infoConfirmed && blztFlag !== '0'
    return (
      <div style={{ position: 'relative' }}>
        {operable ? (
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu
              ref={'siderMenu'}
              setMenuList={this.setMenuList}
              title="自助报到"
              mkbz={this.state.mkbz}
              menuType="自助报到"
            />
            <Flex.Item className="page_con_r">
              <Breadcrumb
                noLine
                list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]}
              />
              <div className="box">
                <Hint />
                <TitleTop title="个人信息确认" extra={false} />
                <Spin spinning={loading}>{this.renderInfo()}</Spin>
                <div className="p-sw text-center mt-30">
                  <Button type="primary" loading={confirmLoading} onClick={this.handleConfirm} disabled={infoConfirmed}>
                    {infoConfirmed ? '已确认' : '确认信息无误'}
                  </Button>
                  <NextButton nextUrl={nextUrl} search={search} disabled={!canNext} />
                </div>
              </div>
            </Flex.Item>
          </Flex>
        ) : (
          <div className="w1180 mt-20 infoConfirmTip">暂不可办理该环节</div>
        )}
      </div>
    )
  }
}
